<template>
  <div
    class="sport-periods flex-center text-center text-upper font-bold"
    :class="{ 'sport-tennis': isTennis }">
    <span
      class="sport-period-name"
      :class="{ 'period-tennis': isTennis }"
      v-for="(period, index) in periods"
      :key="index">
      {{ period | translate }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SportHeaderPeriod',
  props: {
    idSport: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      sportCurrentPeriod: {
        1: 'soccerMarker', // Soccer
        2: 'basketballMarker', // Basketball
        3: 'baseballMarker', // Baseball
        4: 'icehockeyMarker', // Ice hockey
        5: 'tabletennisMarker', // Tennis
        6: 'handballMarker', // Handball
        12: 'rugbyMarker', // Rugby
        16: 'rugbyMarker', // American footbal
        19: 'snookerMarker', // Snooker
        20: 'tabletennisMarker', // Table tennis
        23: 'volleyballMarker', // Volleyball
        29: 'futsalMarker', // Futsal
        31: 'badmintonMarker', // Badminton
        32: 'bowlsMarker', // Bowling
        34: 'beachvolleyMarker', // Beach volleybal
        37: 'squashMarker', // Squash
      },
    };
  },
  computed: {
    isTennis() {
      return this.idSport === 5;
    },
    isCricket() {
      return this.idSport === 21;
    },
    periods() {
      const periods = [];
      const sportCurrentPeriod = this.sportCurrentPeriod[this.idSport];

      if (this.isTennis) {
        periods.push(sportCurrentPeriod, 'gamePoints');
      } else if (this.isCricket) {
        periods.push('resultsShort');
      } else {
        periods.push('resultsShort', sportCurrentPeriod);
      }

      return periods;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.sport-periods {
  line-height: $sport-header-bet-bottom-height;
  width: $match-results-width;
  background-color: $sport-header-period-color-back;
  font-size: 0.62rem;
  color: $color-important-special;

  &.sport-tennis {
    width: $match-results-tennis-width;
  }

  .sport-period-name {
    width: 50%;
    &.period-tennis:first-child { width: 40%; }
    &.period-tennis:last-child { width: 60%; }
  }
}
</style>
